import { Component, Input, OnInit, TemplateRef, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE, INJECT_TYPE } from 'src/app/constants';
import { CheckCustomerNecessaryFilesComponent } from 'src/app/Customer/check-customer-necessary-files/check-customer-necessary-files.component';
import { DialogItem } from 'src/app/dialog-item';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { Contact } from 'src/model/contact.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { EPF } from 'src/model/epf.model';
import { AccountAuthorizationService } from 'src/services/accountAuthorization.service';
import { ContactService } from 'src/services/contact.service';
import { CustomerService } from 'src/services/customer.service';
import { EpfService } from 'src/services/epf.service';
import { AccountAuthorizationHistoryComponent } from '../accountAuthorizationHistory/accountAuthorizationHistory.component';

@Component({
    selector: 'app-process-authorization',
    templateUrl: './process-authorization.component.html',
    styleUrl: './process-authorization.component.scss',
    standalone: false
})
export class ProcessAuthorizationComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private contactService = inject(ContactService);
  protected sharedService = inject(SharedService);
  private accountAuthorizationService = inject(AccountAuthorizationService);
  private epfSevice = inject(EpfService);
  private router = inject(Router);
  private customerService = inject(CustomerService);

  @Input() authorization: AccountAuthorization;
  @Input() accountDetails: CustomerAccount;
  contactDetails: Contact;
  remark: string;
  grantDueDate: Date;
  isGrant = false;
  untilEPFDate = false;
  epfDetails: EPF;
  disabledSubmit = false;

  customerDetailsTemplate = viewChild.required<TemplateRef<any>>('customerDetails');

  async ngOnInit(): Promise<void> {
    if (this.accountDetails.ContactId != undefined)
      this.contactDetails = await this.contactService.getContactById(this.accountDetails.CustomerId, this.accountDetails.ContactId);
    this.epfDetails = await this.epfSevice.getCustomerEPF(this.accountDetails.CustomerId);
  }

  openAuthorizationHistoryModal(account: CustomerAccount) {
    const modalRef = this.sharedService.openModal(AccountAuthorizationHistoryComponent, "regularModal");
    modalRef.componentInstance.accountDetails = account;
  }

  async openCustomerImagesModal(customerId: number) {
    const files = await this.customerService.getCustomerAllFiles(customerId);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
    i.injectContent = [new DialogItem(CheckCustomerNecessaryFilesComponent, { customerId: customerId })];
    i.imgViewerInjectContent = [new DialogItem(this.customerDetailsTemplate(), { name: this.authorization?.CustomerName, ic: this.sharedService.processICNum(this.authorization?.CustomerIC) }, INJECT_TYPE.TEMPLATE)];
  }

  validateFields(isGrant: boolean) {
    let errorStr = "";
    if (isGrant && this.grantDueDate == undefined)
      errorStr += "- Grant Due Date";

    if (this.remark == undefined)
      errorStr += "- Remark"

    return errorStr;
  }

  setGrantDateToEPFDate() {
    this.grantDueDate = new Date(this.epfDetails.Date);
    this.grantDueDate.setHours(23, 59, 59, 999);
  }

  submit() {
    const error = this.validateFields(this.isGrant);
    if (error != "")
      this.sharedService.openAlert("Please check following fields:\n" + error, ALERT_TYPE.DANGER);
    else
      this.confirmBeforeAction(this.isGrant);
  }

  confirmBeforeAction(isGrant: boolean) {
    this.disabledSubmit = true;

    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    const grantMessage = (isGrant == true) ? "GRANT" : "REJECT";
    modalRef.componentInstance.message = "Confirm to " + grantMessage + " this account?";
    modalRef.result.then(async (confirm) => {
      let result;
      if (confirm) {
        if (isGrant == true) {
          this.authorization.GrantedRemark = this.remark;
          this.authorization.GrantedUntil = this.grantDueDate;
          result = await this.accountAuthorizationService.grantAuthorization(this.authorization.ID, this.authorization);
        } else {
          this.authorization.RevokedRemark = this.remark;
          result = await this.accountAuthorizationService.revokeAuthorization(this.authorization.ID, this.authorization);
        }

        if ((result instanceof AccountAuthorization))
          window.location.reload();
      }
    });
  }

  goToCustomer(customerID: number) {
    this.activeModal.close();
    this.router.navigate(['/manageCustomer', customerID]);
  }

  reset() {
    this.activeModal.close();
  }
}
